import {
  Wrench,
  Archive,
  FolderInput,
  PlusCircle,
  ArrowRight,
  Reply,
  PencilOff,
  TicketPlusIcon,
  Forward,
  MailOpen,
} from 'lucide-react';

import { getAssistantActions } from '../../utils/taskActions';
import { formatActionTypeLabel } from '../../utils/formatter';

const ICON_SIZE = 14;
const iconTransition = 'transition-colors';
const buttonTransition = 'transition-colors';

const getActionConfig = (action, item, readOnlyMode) => {
  switch (action.type) {
    case 'archive':
      return {
        Icon: (readOnlyMode && !item?.archived) ? PencilOff : Archive,
        iconClass: `text-stone-600 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-stone-50 border border-stone-100 group-hover:bg-stone-500 group-hover:border-stone-500 ${buttonTransition}`,
      };
    case 'reply':
      return {
        Icon: Reply,
        iconClass: `text-cyan-700 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-cyan-50 group-hover:bg-cyan-700 ${buttonTransition}`,
      };
    case 'forward':
      return {
        Icon: Forward,
        iconClass: `text-sky-700 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-sky-50 group-hover:bg-sky-700 ${buttonTransition}`,
      };
    case 'markRead':
      return {
        Icon: MailOpen,
        iconClass: `text-teal-600 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-teal-50 group-hover:bg-teal-600 ${buttonTransition}`,
      };
    case 'move-to-label':
      return {
        Icon: (readOnlyMode && !item?.archived) ? PencilOff : ArrowRight,
        iconClass: `text-indigo-600 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-indigo-50 group-hover:bg-indigo-600 ${buttonTransition}`,
      };
    case 'create-a-task':
      return {
        Icon: PlusCircle,
        iconClass: `text-emerald-600 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-emerald-50 group-hover:bg-emerald-600 ${buttonTransition}`,
      };
    case 'create-a-maintenance-ticket':
      return {
        Icon: TicketPlusIcon,
        iconClass: `text-emerald-600 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-emerald-50 group-hover:bg-emerald-600 ${buttonTransition}`,
      };
    case 'add-to-project':
      return {
        Icon: FolderInput,
        iconClass: `text-indigo-700 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-indigo-100 border border-indigo-100 group-hover:bg-indigo-700 group-hover:border-indigo-700 ${buttonTransition}`,
      };
    default:
      return {
        Icon: Wrench,
        iconClass: `text-stone-500 group-hover:text-white ${iconTransition}`,
        buttonClass: `bg-stone-50 border border-stone-100 group-hover:bg-stone-500 group-hover:border-stone-500 ${buttonTransition}`,
      };
  }
};

export const EmailActionItems = ({ item, labels, readOnlyMode, onActionClick }) => {
  const actions = getAssistantActions(item?.actions);

  if (!actions?.length) {
    return null;
  }

  return (
    <div className="flex flex-row items-center gap-1 shrink-0">
      <span className="text-stone-400 text-xs">|</span>
      {actions.map((action, actionIndex) => {
        const { Icon, iconClass, buttonClass } = getActionConfig(action, item, readOnlyMode);

        return (
          <button
            key={`action-item-${actionIndex}-${action.type}`}
            type="button"
            title={formatActionTypeLabel(action, labels)}
            onClick={(event) => {
              event.stopPropagation();
              onActionClick?.(action);
            }}
            data-amp-track-section="Digest Email Action"
            data-amp-track-action="Action_Icon_Click"
            data-amp-track-action_type={action.type}
            className={`group px-2 py-1.5 rounded-full ${buttonClass}`}
          >
            <Icon size={ICON_SIZE} className={iconClass} />
          </button>
        );
      })}
    </div>
  );
};

export default EmailActionItems;
